export const toHandicap = (value: string | number | undefined | null) => {
  if (value === undefined || value === null) {
    return 'TBD';
  }

  if (value === '+') {
    return value;
  }

  const splittedValue = String(value).split('.');

  const wholePart =
    splittedValue[0][0] === '-' ? `+${Math.abs(Number(splittedValue[0]))}` : splittedValue[0];

  return `${wholePart}${splittedValue[1] ? `.${splittedValue[1][0]}` : ''}`;
};
